// Formatter centralizzato appellativo professionale.
// Il DB memorizza SOLO il codice canonico (doctor_m|doctor_f); l'abbreviazione dipende dalla lingua attiva.
const ABBR = {
  it: { doctor_m: "Dott.", doctor_f: "Dott.ssa" },
  en: { doctor_m: "Dr.", doctor_f: "Dr." },
  de: { doctor_m: "Dr.", doctor_f: "Dr." },
  fr: { doctor_m: "Dr", doctor_f: "Dre" },
};

// Evita la duplicazione se il nome storico contiene già un appellativo scritto a mano.
const TITLE_PREFIX_RE = /^\s*(dott\.?ssa|dott\.?|dr\.?ssa|dre|dr\.?|docteure?|dottoress[ae]|dottore|doktorin|doktor)\b/i;

export function proTitleAbbr(title, lang) {
  if (!title) return "";
  const l = (lang || "it").slice(0, 2).toLowerCase();
  return (ABBR[l] || ABBR.it)[title] || "";
}

// Antepone l'abbreviazione al nome completo. Accetta { title, first_name, last_name } oppure { title, name }.
export function formatProName({ title, first_name, last_name, name } = {}, lang) {
  const full = (name != null ? name : `${first_name || ""} ${last_name || ""}`).trim();
  if (!title || TITLE_PREFIX_RE.test(full)) return full;
  const ab = proTitleAbbr(title, lang);
  return ab ? `${ab} ${full}`.trim() : full;
}
